import React from 'react'
import PropTypes from 'prop-types'
import Link from 'gatsby-link'
import Helmet from 'react-helmet'

import {appleTouchIcon, favicon32x32, favicon16x16, safariPinnedTab} from '../img/meta/metas'

import '../scss/index.scss'

const TemplateWrapper = ({ children }) => (
  <div>
    <Helmet
      title="Parse.ly x Henry Desroches"
      meta={[
        { charset: 'utf-8'},
        { name: 'description', content: 'A simple React app to serve as a cover letter for Henry Desroches for the UX engineer position at Parse.ly.' },
        { name: 'keywords', content: 'front-end developer, UX engineer, parse.ly, henry desroches, creative developer' },
        { name: 'theme-color', content: '#222222'},
      ]}
    >
      <link rel="apple-touch-icon" sizes="180x180" href={appleTouchIcon} />
      <link rel="icon" type="image/png" sizes="32x32" href={favicon32x32} />
      <link rel="icon" type="image/png" sizes="16x16" href={favicon16x16} />
      <link rel="mask-icon" href={safariPinnedTab} color="#222222" />
    </Helmet>
    <div
      style={{
        margin: '0 auto',
        maxWidth: 960,
        padding: '0px 1.0875rem 1.45rem',
        paddingTop: 0,
      }}
    >
      {children()}
    </div>
  </div>
)

TemplateWrapper.propTypes = {
  children: PropTypes.func,
}

export default TemplateWrapper



// WEBPACK FOOTER //
// ./src/layouts/index.js